import { render, staticRenderFns } from "./DataPrivacy.vue?vue&type=template&id=424756f2&scoped=true"
import script from "./DataPrivacy.vue?vue&type=script&lang=js"
export * from "./DataPrivacy.vue?vue&type=script&lang=js"
import style0 from "./DataPrivacy.vue?vue&type=style&index=0&id=424756f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424756f2",
  null
  
)

export default component.exports